<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="CostCenter"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="[]"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="gridColumns && gridColumns.length > 0">
    <kgrid
      #Grid
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      [noToolBar]="true"
      [filtering]="false"
      [groupable]="false"
      [columns]="gridColumns"
      [notLoadData]="true"
      [(dataList)]="model.HrmDiskItemFormats"
      (onCreate)="onCreate($event)"
      (onEdit)="onEdit($event)"
      (onDelete)="onDelete($event)"
      [isMulti]="false"
      [isModal]="false"
      [inputEditorform]="inputEditorform">
    </kgrid>
  </ng-container>
</dynamic-form>
